export default {
  backgroundLayers: 0,
  submitFormAsyncCallback: () => {},
  submitScreenData: null,
  renderPrivacyNotice: false
};
